import {
  CLEAR_CURRENT_IMPORT_RECORD_DATA,
  CLEAR_POWERBI_STORE,
  CLEAR_REPORT_CREATION_DATA,
  INITIATE_POWERBI_IMPORT_PROCESS,
  SAVE_DATASET_LIST,
  SAVE_REPORTS_LIST,
  SET_CREATE_REPORT_MODAL_OPEN,
  SET_EXPORT_PENDING,
  SET_POWERBI_IMPORT_ERROR,
  SET_POWERBI_IMPORT_LOADING,
  SET_POWERBI_IMPORT_MODAL_OPEN,
  SET_POWERBI_IMPORT_STEP,
  SET_REFRESH_DATA,
} from '../actions/PowerBIActions';

const initialState = {
  isImportModalOpen: false,
  isExportPending: false,
  createReportData: { isModalOpen: false },
  currentRecordId: '',
  importRecords: [],
  datasetList: [],
  reportsList: [],
  refreshDate: '',
};

const initialImportConfig = {
  isLoading: false,
  importStep: 0,
  hasImportError: false,
  importKey: '',
  errorMessage: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case INITIATE_POWERBI_IMPORT_PROCESS: {
      return {
        ...state,
        importRecords: {
          ...state.importEntities,
          [state.currentRecordId]: initialImportConfig,
        },
        isImportModalOpen: true,
      };
    }

    case SET_POWERBI_IMPORT_STEP: {
      const { recordId, importStep } = action.payload;

      return {
        ...state,
        importRecords: {
          ...state.importRecords,
          [recordId]: {
            ...state.importRecords[recordId],
            importStep,
          },
        },
      };
    }

    case SET_POWERBI_IMPORT_LOADING: {
      const { flag, recordId } = action.payload;

      return {
        ...state,
        importRecords: {
          ...state.importRecords,
          [recordId]: {
            ...state.importRecords[recordId],
            isLoading: flag,
          },
        },
      };
    }

    case SET_POWERBI_IMPORT_MODAL_OPEN: {
      const { flag, recordId } = action.payload;

      return {
        ...state,
        isImportModalOpen: flag,
        currentRecordId: recordId,
      };
    }

    case SET_CREATE_REPORT_MODAL_OPEN: {
      const { flag, reportData } = action.payload;

      return {
        ...state,
        createReportData: {
          ...reportData,
          isModalOpen: flag,
        },
      };
    }

    case SET_POWERBI_IMPORT_ERROR: {
      const { flag, recordId, message } = action.payload;

      return {
        ...state,
        importRecords: {
          ...state.importRecords,
          [recordId]: {
            ...state.importRecords[recordId],
            hasImportError: flag,
            errorMessage: message,
          },
        },
      };
    }

    case CLEAR_CURRENT_IMPORT_RECORD_DATA: {
      return {
        ...state,
        importRecords: {
          ...state.importRecords,
          [state.currentRecordId]: initialImportConfig,
        },
      };
    }

    case SAVE_DATASET_LIST: {
      const { datasetList } = action.payload;

      return {
        ...state,
        datasetList,
      };
    }

    case SAVE_REPORTS_LIST: {
      const { reportsList } = action.payload;

      return {
        ...state,
        reportsList,
      };
    }

    case SET_EXPORT_PENDING: {
      const { flag } = action.payload;

      return {
        ...state,
        isExportPending: flag,
      };
    }

    case CLEAR_REPORT_CREATION_DATA: {
      return {
        ...state,
        datasetList: [],
        reportsList: [],
      };
    }

    case SET_REFRESH_DATA: {
      const { refreshDataObj } = action.payload;

      return {
        ...state,
        ...refreshDataObj,
      };
    }

    case CLEAR_POWERBI_STORE: {
      return {
        ...initialState,
      };
    }

    default:
      return state;
  }
};
